   $( function() {
var updateSizeAndPrice = function() {
  var widthSize = $(".widthSize-inch");
  var heightSize = $(".heightSize-inch");
  var width = parseInt(widthSize.text());
  var height = parseInt(heightSize.text());
  var size = 'width:' + widthSize.attr("size-data") + ', height:' + heightSize.attr("size-data");
  var price = 0;

  if (width + height != 40) {
    const cost_coef1 = {
      con: -61.43767931,
      x: 2.205711465,
      y: 1.986026393,
      s: -0.000816521,
      c: 1.415596439
    };
    const cost_coef2 = {
      con: 299.883986,
      x: -2.538633704,
      y: -5.360809299,
      s: 0.123439401,
      c: 3.117467307
    };
    const cost_est = function(x, y) {
      const s = x * y;
      const c = x + y + Math.min(x, y);
      let cost;
      if (s < 1900) {
        cost = cost_coef1.con + cost_coef1.x * x + cost_coef1.y * y +
          cost_coef1.s * s + cost_coef1.c * c;
      } else {
        cost = cost_coef2.con + cost_coef2.x * x + cost_coef2.y * y +
          cost_coef2.s * s + cost_coef2.c * c;
      }
      return cost;
    };
    const mult_coef1 = {
      con: 6.856568154,
      x: 0.030422952,
      y: 0.042881326,
      s: 0.000690259,
      c: -0.067146046
    };
    const mult_est1 = function(x, y) {
      const s = x * y;
      const c = x + y + Math.min(x, y);
      const mult = mult_coef1.con + mult_coef1.x * x + mult_coef1.y * y +
        mult_coef1.s * s + mult_coef1.c * c;
      return mult;
    };
    const mult_est3 = function(x, y) {
      const mult = (x + 30) / (y + 30) + 2;
      return mult;
    };
    const mult = function(x, y) {
      const mult1 = mult_est1(x, y);
      const mult3 = mult_est3(x, y);
      const mult = Math.max(mult1, mult3);
      return mult;
    };
    const price_est = function(x, y) {
      return cost_est(x, y) * mult(x, y);
    };

    var price = price_est(width, height);
    price = Math.floor(price) - 436;
  ymqJq('.ymq_size_money input').val( size ).data('price',Number(price)).change();
  }else{
  let price = 0;   
  ymqJq('.ymq_size_money input').val( size ).data('price',Number(price)).change();   
  }  
     if(width >= 22 & height >= 30  ){
              $(".custom-option-select-clock").removeClass("no-drop");
           }else{
             $(".custom-option-select-clock").addClass("no-drop");
         $(".product-options-label-clock").children("span").empty().text("Select");
           ymqJq('.clock input').val("").data('price',0).change();
           }


  
if (width < 32 ) {
    $(".custom-option-select-mirror").addClass("no-drop");
     $(".product-options-label-mirror").children("span").empty().text("Select");
     ymqJq('.makeup-mirror input').val("").data('price',0).change();
     }else if(width >= 32 & width <= 48 ){  
  
$('.custom-option-select-mirror .product-options-single').each(function() {
  var dataVal = $(this).attr('data-val');
  if (dataVal.includes('170')) {
    $(this).hide();
  } else {
    $(this).show();
  }
});
var spanElement = $('.product-options-label-mirror span');
var spanText = spanElement.text();
if (spanText.includes('170')) {
  spanText = spanText.replace('170', '150');
    spanText = spanText.replace('45', '35');
  spanElement.text(spanText);
ymqJq('.makeup-mirror input').val(spanText).data('price','35').change();
}else if(spanText.includes('150')){
  
}else{
  spanElement.text('none');
ymqJq('.makeup-mirror input').val("").data('price',0).change();
}
$(".custom-option-select-mirror").removeClass("no-drop");
       
} else  if(width > 48 ){
  
$('.custom-option-select-mirror .product-options-single').each(function() {
  var dataVal = $(this).attr('data-val');
  if (dataVal.includes('150')) {
    $(this).hide();
  } else {
    $(this).show();
  }
});
var spanElement = $('.product-options-label-mirror span');
var spanText = spanElement.text();
if (spanText.includes('150')) {
  spanText = spanText.replace('150', '170');
    spanText = spanText.replace('35', '45');
  spanElement.text(spanText);
ymqJq('.makeup-mirror input').val(spanText).data('price','45').change();
}else if(spanText.includes('170')){
  
}else{
  spanElement.text('none');
ymqJq('.makeup-mirror input').val("").data('price',0).change();
}
$(".custom-option-select-mirror").removeClass("no-drop");

}


  
          if(width>= 40 & height >= 32  ){
                $(".custom-option-select-wifi").removeClass("no-drop")
                $(".custom-option-select-bluetooth").removeClass("no-drop");
                $(".custom-option-select-demister").removeClass("no-drop")
             }else{
                     $(".custom-option-select-wifi").addClass("no-drop");
                     $(".custom-option-select-bluetooth").addClass("no-drop");
                     $(".custom-option-select-demister").addClass("no-drop");        
                     $(".product-options-label-wifi").children("span").empty().text("Select");
                     $(".product-options-label-bluetooth").children("span").empty().text("Select");
                     $(".product-options-label-demister").children("span").empty().text("Select");
                     ymqJq('.clock-wifi input').val("").data('price',0).change();
                     ymqJq('.bluetooth-speaker input').val("").data('price',0).change();
                     ymqJq('.demister input').val("").data('price',0).change();  
               }

                  if(width >=80 || height >=80 ){
                   $(".product-options-single-rush").removeClass("product-options-single").addClass("product-options-single-rush-no")
                  $(".product-options-label-rush").children("span").empty().text("Select"); 
                  $(".options-single-rush-p").css("color","#b9083a")
           ymqJq('.delivery input').val("").data('price',0).change();
                }else{
             $(".product-options-single-rush").addClass("product-options-single").removeClass("product-options-single-rush-no") 
             $(".options-single-rush-p").css("color","#a9a9a9")
                }
if (width >= 78) {
$(".custom-option-select-edge").addClass("no-drop");
$(".product-options-select-edge").children("span").empty().text("Select");
ymqJq('.mirror-edge input').val("").data('price',0).change();
} else {
  $(".custom-option-select-edge").removeClass("no-drop"); 
}
};

$(".product-options-single-size-width>li, .product-options-single-size-height>li").on('click', function(){
var size = $(this).text();
$(this).parent().siblings().children("span").empty().text(size);
$(this).parent().siblings().children("span").attr("size-data", size);
$(".product-options-single-size").removeClass("active");
updateSizeAndPrice();
})


  $(".product-options-label").on('click', function(){
    $(this).children(".icon--chevron").toggleClass("ico-rotate")
    $(this).siblings().toggleClass("active");
     $(this).parent().parent().siblings().children().children(".product-options-content").removeClass("active");
    
  })

  $(".product-options-single").on('click', function(){
  $(".product-options-content").removeClass("active");
 $(".icon--chevron").removeClass("ico-rotate");
 var val = $(this).attr("data-val");
var pricei = $(this).attr("data-price");  
var vall = val + '\xa0' +'\xa0' + pricei;
  if (typeof(pricei)=="undefined" ){
$(this).parent().siblings().children("span").empty().text(val);
  }else{
 $(this).parent().siblings().children("span").empty().text(vall);   
  }  
var attr = $(this).parent().siblings().attr("data-attr");   
 switch(attr){
  case ("Mirror Edge Craftsmanship"):
   if(val == 'none'){ 
 ymqJq('.mirror-edge input').val(val).data('price',0).change();
   }else{
 ymqJq('.mirror-edge input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
   }
 break;

     
  case ("Color Temperature"):
   if(val == 'Tri-color (interchangeable LED colors)'){
      ymqJq('.color-temperature input').val( val ).data('price',0).change();
   }else{
      ymqJq('.color-temperature input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
   }

 break;
     
  case ("Illumination Switch"):
     if( val == "Touch Switch"){
 ymqJq('.Illumination-switch input').val( val ).data('price',0).change();
     } else{    
 ymqJq('.Illumination-switch input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
     }
 break;
     
   case ("Adapter"):
 ymqJq('.adapter input').val( val ).data('price',0).change();
 break;

   case ("Backlight"):
     if( val == "none"){
 ymqJq('.backlight input').val( val ).data('price',0).change();
     } else{
 ymqJq('.backlight input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
     }
 break;

        case ("Frame"):
     if ($(this).data('price')) {
    ymqJq('.frame input').val(val).data('price', Number(pricei.replace(/[^0-9\.-]+/g, ""))).change();
} else {
    ymqJq('.frame input').val(val).data('price', 0).change();
}
 break;

  case ("Demister"):
if( val == "none"){
 ymqJq('.demister input').val( val ).data('price',0).change();
}else{
  ymqJq('.demister input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change(); 
}
 break;

  case ("Makeup Mirror"):
if( val == "none"){
   ymqJq('.makeup-mirror input').val( val ).data('price',0).change();
}else{
   ymqJq('.makeup-mirror input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
}


 break;


  case ("Bluetooth Speaker"):
     if( val == "none"){
 ymqJq('.bluetooth-speaker input').val( val ).data('price',0).change();
}else{
 ymqJq('.bluetooth-speaker input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
  }
 break;

  case ("Clock/ WIFI Weather Station"):
if( val == "none"){
   ymqJq('.clock-wifi input').val( val ).data('price',0).change();
}else {
   ymqJq('.clock-wifi input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
}   
 break;

  case ("Clock"):
if( val == "none"){
   ymqJq('.clock input').val( val ).data('price',0).change();
}else {
   ymqJq('.clock input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
}   
 break;

 case ("Delivery Time"):
var Widthinch =  parseInt($(".widthSize-inch").text());
if( val == "Free Standard Delivery (8-10 weeks)"){
 ymqJq('.delivery input').val( val ).data('price',0).change();

}else if ( val == "Rush Service (5-6 weeks)") {
if( Widthinch >= 80 ){
   $(this).parent().siblings().children("span").empty().text("Free Standard Delivery (8-10 weeks)"); 
 ymqJq('.delivery input').val( "Free Standard Delivery (8-10 weeks)" ).data('price',0).change(); 
}else{
 ymqJq('.delivery input').val( val ).data('price',Number(pricei.replace(/[^0-9\.-]+/g,""))).change();
}

  }
 break;       
  }      
  })     

      $(".product-options-label-delivery>.product-options-single").on('click', function(){
$(this).parent().siblings().removeClass("border-cuistom").parent().siblings().removeClass("font-cuistom")
var val = $(this).attr("data-val");
if ( val == "Free Standard Delivery (8-10 weeks)" || val == "Rush Service (5-6 weeks)" ){

   $(".flase-add-to-cart").addClass("hidden")
$("#AddToCart").removeClass("hidden")
    $(".add-flase-p").addClass("hidden"); 

}else{
$(".flase-add-to-cart").removeClass("hidden")
$("#AddToCart").addClass("hidden")
 $(".add-flase-p").removeClass("hidden"); 

  
}
  }) 

   var ico = `<div class="option-label-i-ico">More information</div>`;
 $(".option-label-i").hover(function(){
           $(this).append(ico);
    }, function() {  
  $(".option-label-i-ico").remove();
   }) 

   $(".option-label-i").on('click', function(){
     $(this).siblings(".option-label-i-content").addClass("active");
         $(".option-label-i-content").hover(function(){
    }, function() {  
     $(this).removeClass("active")
   }) 
  }) 
   $(".option-label-i-content span").on('click', function(){
     $(".option-label-i-content").removeClass("active")
  }) 

  $(".flase-add-to-cart").on('click', function(){
$(".add-flase-p").removeClass("hidden");
  var del = $(".false-deliviry").text();   
    if ( del== "Select" ){
  $(".false-deliviry").parent().addClass("border-cuistom").parent().siblings().addClass("font-cuistom")
}
 })

})